import { render } from "./PortfolioComponent.vue?vue&type=template&id=0236b74b&scoped=true"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js"

import "./PortfolioComponent.vue?vue&type=style&index=0&id=0236b74b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0236b74b"]])

export default __exports__